import { DateRow, PriceRow, TextRow, TextToolTip, TypeRow } from 'components';
import React from 'react';
import { Images } from 'utils';
import {
  paymentMethodENums,
  paymentMethods,
  sourceList,
} from '../../../fragments/customerPayment/customerPaymentDetails/constants';

const hasActiveDocument = (item) => item?.documents?.some((doc) => doc?.status === 'ACTIVE');

const statusEnums = {
  APPLIED: 'APPLIED',
  OPEN: 'OPEN',
  VOIDED: 'VOIDED',
}
export const customerPmtHead = [
  { name: '', title: 'Created Date', icon: 'date', type: 'date',  width: 150 },
  { name: '', title: 'Pmt Date', custom: false, width: 150 },
  { name: 'customer', searchKey: 'customer', title: 'Factoring/Customer', custom: false },
  {
    name: 'source', title: 'Source',
    filterList: [
      { name: 'All', id: '' },
      ...sourceList
    ],
  },
  {
    name: 'pmtMethod', title: 'Method',
    filterList: [
      { name: 'All', id: '' },
      ...paymentMethods
    ],
  },
  { name: 'applied',  searchKey:'used', title: 'Applied', custom: false },
  { name: 'total',  title: 'Total', custom: false },
  { name: '', title: 'Remaining', custom: false, smallSize: 8 },
  { name: 'reference', searchKey: 'reference', title: 'Ref. Number', custom: false, smallSize: 6 },
  { name: '', title: 'Doc', custom: false, width: 50 },
  {
    name: 'status', title: 'Status',
    filterList: [
      { name: 'All', id: '' },
      { name: 'Applied', id: 'APPLIED' },
      { name: 'Open', id: 'OPEN' },
      { name: 'Voided', id: 'VOIDED' },
    ],
  },
];

const renderColor = (item) => {
  switch (item?.status) {
    case statusEnums.OPEN:
      return '#F79009';

    case statusEnums.VOIDED:
      return '#438BFE';

    case statusEnums.APPLIED:
      return '#43BA4D';

    default:
      return '#51566d'
  }
}
export const customerPmtBody = [
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <DateRow date={item?.pmtDate} /> },
  { rowText: (item) => <TextRow name={item?.factoringName ? item?.factoringName : item?.customerName} /> },
  { rowText: (item) => <TypeRow text={item?.source}  /> },
  { rowText: (item) => <TypeRow text={item?.pmtMethod}  /> },
  { rowText: (item) => <PriceRow info={item?.used} /> },
  { rowText: (item) => <PriceRow info={item?.amount} /> },
  { rowText: (item) => <PriceRow info={item?.amount - item?.used} /> },
  { rowText: (item) => <TextRow name={item?.reference} /> },
  {
    rowText: (item) => hasActiveDocument(item)
      ? <TextToolTip
          showTooltip
          arrow
          content="Document Attached"
          text={<img src={Images.FileSvg} alt="doc" style={{ width: 18, height: 18 }} />}
          wrapperStyles={{ minWidth: 'fit-content', width: 'fit-content' }}
        />
      : <span style={{ color: '#9CA3AF' }}>-</span>,
  },
  { rowText: (item) => <div style={{color: renderColor(item) }}><TypeRow text={item?.status} /></div> },
];

export const ACTION_TYPE = 'GET_CUSTOMER_PAYMENT';

export const customerPaymentsStatuses = [
  { id: 'OVERVIEW', name: 'Overview' },
  { id: 'DETAILED', name: 'Detailed' },
];

export const customerPaymentCsv = {
  type: 'customerPayment',
  statusList: customerPaymentsStatuses,
  dateFilter: true,
  requiredDateRange: true,
  requiredStatus: true,
};